<app-tools-catalogue-menu
  [breadcrumbLinks]="breadcrumbLinks"
></app-tools-catalogue-menu>

<div class="container m-b-xxl m-t-alt">
  <div class="columns is-multiline">
    <div class="column">
      <h1 class="title is-2 mb-0">
        Contribute your tools and metrics to our catalogue
      </h1>
      <p>
        This catalogue is a platform where AI practitioners from all over the
        world can share and compare tools and metrics to help make AI
        trustworthy, build upon each other’s efforts to create global good
        practices, and speed up the process of implementing the OECD AI
        Principles.
      </p>
      <p>
        <strong
          >This catalogue can only exist with your contributions and those of AI
          practitioners from all sectors.</strong
        >
      </p>
      <p>
        <strong>Do you know of any tools or metrics </strong> to help make AI
        trustworthy? If so, <strong>please submit them</strong> to our
        catalogue.
      </p>
      <p>
        <strong>You can also share your experience</strong> using a tool or
        metric
        <strong>by submitting a use case.</strong>
      </p>
    </div>
  </div>

  <!-- Cards -->
  <div class="columns is-multiline">
    <div class="column is-6">
      <div class="card has-background-white-ter no-border is-full-height">
        <div>
          <div class="media mb-0">
            <div class="media-left">
              <figure class="image is-32x32">
                <div class="icon-wrapper mr-2">
                  <div class="has-background-danger-bis"></div>
                  <span class="icon is-size-6">
                    <em class="fas fa-th-large has-text-danger-bis"></em>
                  </span>
                </div>
              </figure>
            </div>
            <div class="media-content">
              <h2 class="title is-4 mt-2 mb-3">Tools</h2>
            </div>
          </div>
          <div class="content is-small mb-0 mt-4">
            <span>
              <i class="fas fa-arrow-alt-circle-right has-text-link mr-2"></i
              ><a routerLink="/catalogue/tools/submit"
                >Contribute a tool</a
              ></span
            >
          </div>
          <div class="content is-small">
            <span>
              <i class="fas fa-arrow-alt-circle-right has-text-link mr-2"></i
              ><a routerLink="/catalogue/tool-use-cases/submit"
                >Share your experience using a tool</a
              ></span
            >
          </div>
        </div>
      </div>
    </div>

    <div class="column is-6">
      <div class="card has-background-white-ter no-border is-full-height">
        <div>
          <div class="media mb-0">
            <div class="media-left">
              <figure class="image is-32x32">
                <div class="icon-wrapper mr-2">
                  <div class="has-background-color-purple"></div>
                  <span class="icon is-size-6">
                    <em class="fas fa-puzzle-piece has-text-color-purple"></em>
                  </span>
                </div>
              </figure>
            </div>
            <div class="media-content">
              <h2 class="title is-4 mt-2 mb-3">Metrics</h2>
            </div>
          </div>
          <div class="content is-small mt-4 mb-0">
            <span>
              <i class="fas fa-arrow-alt-circle-right has-text-link mr-2"></i
              ><a routerLink="/catalogue/metrics/submit"
                >Contribute a metric</a
              ></span
            >
          </div>
          <div class="content is-small">
            <span>
              <i class="fas fa-arrow-alt-circle-right has-text-link mr-2"></i
              ><a routerLink="/catalogue/metric-use-cases/submit"
                >Share your experience using a metric</a
              ></span
            >
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="columns">
    <div class="column is-12">
      <div class="card has-background-white-ter no-border">
        <span>
          <i class="fa fa-comment has-text-primary mr-2"></i> Questions ?
          <a routerLink="/contact"> Get in touch !</a>
          <span>
            or visit our <a routerLink="/catalogue/faq">about page</a></span
          >
        </span>
      </div>
    </div>
  </div>
</div>

<app-tools-catalogue-disclaimer></app-tools-catalogue-disclaimer>
